import { atom } from 'jotai';
import { TableDataState, TableFilters, TableState, TblStats, TblView } from '../../../../core/table/table.types';
import { tableStatsVM, tableViewVM, tableStateVM } from '../../../../core/table/table_view_models';
import { MonitorItem } from '../../data/datamonitorRepo';

export const monitorStatusTableStateAtom = atom<TableState>(tableStateVM());
export const monitorStatusTableViewAtom = atom<TblView>(tableViewVM());
export const monitorStatusTableFiltersAtom = atom<TableFilters>({});
export const monitorStatusTableStatsAtom = atom<TblStats>(tableStatsVM());
export const monitorStatusDataAtom = atom<TableDataState<MonitorItem>>({ items: [], dataItems: [] });
